import { useState, useEffect } from 'react';
import PromotionalSalesPage from '../../../models/PromotionalSalesPage';

// The promotional sales pages for a pricelist, and whether we actually got an
// ANSWER about them.
//
// ⚠️ A FAILED REQUEST IS NOT AN ANSWER. Without `isError` the catch-less promise
// left `data` at [] and `isLoading` false, which is indistinguishable from "this
// pricelist has no promotions" -- and a caller that NAVIGATES on that reading
// (the sport team-picture page, which skips the review screen) would walk the
// customer straight past a promo page they should have seen, losing the sale
// silently. Callers that merely render can ignore it; callers that route must
// treat an error as "not answered".
//
// studentId, schoolId and cartId are effect dependencies, not just arguments:
// they can arrive after packageId does, and with `[packageId]` alone the one
// fetch went out with them undefined and `studentHasPurchasedPackage` came back
// computed against nobody, never to be asked again.
export default function usePromotionalSalesPages(packageId, schoolId, studentId, cartId) {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    if (!packageId) return;

    setIsLoading(true);
    setIsError(false);

    PromotionalSalesPage
      .where({ packageId })
      .order('position')
      .extraParams({ schoolId, studentId, cartId, packageId })
      .all()
      .then((res) => setData(res.data))
      .catch(() => setIsError(true))
      .finally(() => setIsLoading(false));
  }, [packageId, schoolId, studentId, cartId]);

  return {
    data,
    isLoading,
    isError,
  };
}
